import { useMutation } from "@tanstack/react-query";

import { updateContactDetail, UpdateContactDetailPayload } from "#/api/contactDetails.api";
import { ContactDetailsType } from "#/api/contactDetails.type";

export function useUpdateContactDetail() {
  return useMutation<ContactDetailsType, Error, { id: string; payload: UpdateContactDetailPayload }>({
    mutationKey: ["contact-detail", "update"],
    mutationFn: ({ id, payload }) => updateContactDetail(id, payload),
  });
}

export default useUpdateContactDetail;
